export default __webpack_public_path__ + "static/media/chainlink.fca72201.jpg";